export const activeAddressBookModals = {
  DELIVERY: 'delivery',
  BILLING: 'billing',
  POS_CREDIT: 'posCredit',
};

export const activeAddressBookModalViews = {
  NEW: 'new',
  EDIT: 'edit',
} as const;

export type ActiveAddressBookModals = (typeof activeAddressBookModals)[keyof typeof activeAddressBookModals];
export type ActiveAddressBookModalView = (typeof activeAddressBookModalViews)[keyof typeof activeAddressBookModalViews];

export const ADDRESS_BOOK_MODAL_STATE_KEY = 'activeAddressBookModal';
